import { useContext } from 'react'
import { useGetCatalogFromStoreQuery, useGetSubscriptionStoreQuery, useHowManyResourcesQuery, usePropertyClassTypeQuery } from 'src/api/api.generated'
import { hicContext } from 'src/app/hooks/context/context'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'

export default function BuyNowCrud({ propertyId, tenantId }: { propertyId: string; tenantId: string }) {
  const showError = useErrorSnackBar()

  const { context } = useContext(hicContext)
  const isTrial = !context.loading && context.isTrial

  const skipQueries =!propertyId || !tenantId || !isTrial

  const { data: propertyClassTypeData, loading: propertyClassTypeLoading } = usePropertyClassTypeQuery({
    variables: {
      filter: {
        id: {
          eq: propertyId,
        },
        tenantId: {
          eq: tenantId,
        },
      },
    },
    onError: showError,
    skip: skipQueries,
  })
  const propertyClassType = propertyClassTypeData?.properties?.[0]?.classType?.description.find((localizedString) => localizedString.language === 'it')?.value ?? null

  const { data: howManyResourcesData, loading: howManyResourcesLoading } = useHowManyResourcesQuery({
    variables: {
      filter: {
        propertyId: {
          eq: propertyId,
        },
        tenantId: {
          eq: tenantId,
        },
      },
    },
    onError: showError,
    skip: skipQueries,
  })
  const howManyResources = howManyResourcesData?.resources?.length ?? null

  const { data: getCatalogFromStoreData, loading: getCatalogFromStoreLoading } = useGetCatalogFromStoreQuery({
    variables: {
      tenantId,
    },
    onError: showError,
    skip: skipQueries,
  })
  const storeCatalog = getCatalogFromStoreData?.getCatalogFromStore ?? null

  const { data: subscriptionStoreData, loading: subscriptionStoreLoading } = useGetSubscriptionStoreQuery({
    onError: showError,
    variables: {
      input: {
        propertyId,
        tenantId,
        featureCode: 'PMS',
      },
    },
    skip: skipQueries,
  })
  const subscriptionIdToUpgrade = subscriptionStoreData?.getSubscriptionStore ?? ''

  return {
    loading: propertyClassTypeLoading || howManyResourcesLoading || getCatalogFromStoreLoading || subscriptionStoreLoading,
    propertyClassType,
    howManyResources,
    storeCatalog,
    subscriptionIdToUpgrade,
  }
}
